<template>
  <v-expansion-panel v-if="loggedRecruiter">
    <expansion-panel-header
      :interview="interviews"
      :interviewId="interviewId"
      :isInterviewer="isInterviewer"
      @closeOpen="closeOpen()"
    />
    <v-expansion-panel-content style="height: 0.1px;">
      <v-dialog v-model="dialog" width="900" persistent>
        <v-card>
          <v-row class="px-5 pt-2">
            <!-- {{ dialog }} -->
            <v-col cols="12" md="8" xl="9">
              <v-row class="mb-1 pt-2">
                <div>
                  <v-btn icon color="primary" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-row>
              <classification
                :interviewId="interviewId"
                :interviews="interviews"
                :selectedCandidate="selectedCandidate"
                :selectedRecruter="selectedRecruter"
                :isCompleted="true"
                :isRunning="false"
                :isInterviewer="isInterviewer"
                :isObserver="isObserver"
                :selectedStage="selectedStage"
                class="mb-10"
              />
              <comments
                :interviewId="interviewId"
                :interviews="interviews"
                :selectedCandidate="selectedCandidate"
                :selectedRecruter="selectedRecruter"
                :selectedStage="selectedStage"
                :isCompleted="true"
                :isRunning="false"
                class="mb-12"
              />
            </v-col>

            <v-col cols="12" md="4" xl="3" class="mr-0 pr-0 mt-11">
              <results
                :interviewId="interviewId"
                :interviews="interviews"
                :selectedCandidate="selectedCandidate"
                :selectedRecruter="selectedRecruter"
                :selectedStage="selectedStage"
                :isCompleted="true"
                :isRunning="false"
                :isInterviewer="isInterviewer"
                :isRunningButNotJoined="isRunningButNotJoined"
                @chageStage="chageStage"
                @updatedState="isLoading2 = false"
              />

              <div class="whirelab-results mt-3">
                <div class="d-flex flex-column mb-2">
                  <div style="font-size: 15px">
                    {{ $t("recruitment_stages") }}
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" class="ml-2" color="primary">
                          mdi-information-variant-circle-outline
                        </v-icon>
                      </template>
                      <div
                        style="width: 180px;"
                        v-html="$t('See_recruitment_stages_scores')"
                      ></div>
                    </v-tooltip>
                  </div>
                  <!-- <div>
                  <v-btn
                    small
                    block
                    color="primary"
                    class="mt-2"
                    @click="openAddStage()"
                    >{{ $t("add_new_stage") }}
                    <v-icon small>mdi-plus</v-icon></v-btn
                  >
                </div> -->
                </div>
                <div
                  v-for="stage in vacancy.candidacies[getCandidacyIndex].stages"
                  :key="stage.name"
                  class=" align-center"
                >
                  <v-list-item two-line style="padding-left: 0">
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2 font-weight-bold black--text"
                        >{{ stage.name }}
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              v-on="on"
                              class="ml-2 mr-2"
                              color="primary"
                            >
                              mdi-information-variant-circle-outline
                            </v-icon>
                          </template>
                          <div
                            style="width: 180px"
                            v-html="stage.analyze"
                          ></div> </v-tooltip
                      ></v-list-item-title>
                      <span style="font-size: 10.8pt;">
                        {{ $t("start_date_time") }}:</span
                      >
                      <v-list-item-subtitle
                        class=" font-weight-regular"
                        style="font-size: 10pt;"
                      >
                        {{ dateFormat(stage.startDate) }}
                        {{ $t("at_") }}
                        {{ stage.startTime }}
                      </v-list-item-subtitle>
                      <span style="font-size: 10.8pt; margin-top: 2.5%;"
                        >{{ $t("end_date_time") }}:</span
                      >
                      <v-list-item-subtitle
                        class="font-weight-regular"
                        style="font-size: 10pt;"
                      >
                        {{ dateFormat(stage.endDate) }}
                        {{ $t("at_") }}
                        {{ stage.endTime }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <pre>{{ stage.participants }}</pre> -->
                  <P style="margin-top: -3%;"
                    >{{ $t("participants") }}:
                    <div>
                      <avatar-group :items="stage.participants" />
                    </div>
                  </P>
                  <v-divider style="margin-top: -3%;"></v-divider>
                </div>
              </div>

              <recruter-list
                :interviewId="interviewId"
                :interviews="interviews"
                :selectedCandidate="selectedCandidate"
                :selectedRecruter="selectedRecruter"
                :isCompleted="true"
                :isRunning="isRunning"
                :isInterviewer="isInterviewer"
                class="mb-1"
                @select="selectRecruter"
              />

              <!-- <v-col cols="12" md="12">
              <div
                v-if="!isCompleted && isInterviewer"
                v-show="!isRunning"
                class="text-right mt-0 mb-10"
              >
                <v-btn
                  text
                  small
                  color="primary"
                  class="mt-12"
                  @click="dialog = false"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <!- <v-btn
                  small
                  color="primary"
                  class="mt-12"
                  @click="openFinishDialog()"
                >
                  {{ $t("finish") }} {{ $t("interview") }}
                </v-btn> ->
              </div>
            </v-col> -->
            </v-col>

            <!-- <v-col cols="12" md="12" class="text-right px-10 py-10">
            <v-btn text small color="primary">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn small color="primary">
              {{ $t("finish") }}
            </v-btn>
          </v-col> -->
          </v-row>
        </v-card>
      </v-dialog>
    </v-expansion-panel-content>

    <notes
      :dialog="noteDialog"
      :interviewId="interviewId"
      :selectedCandidate="selectedCandidate"
      :isRunning="isRunning"
      @close="noteDialog = false"
    />

    <progress-dialog :processing="isLoading" />

    <!-- <stage-dialog
        :dialog="dialogStages"
        :vacancyId="vacancyId"
        :language="getPublishingLang($i18n.locale)"
        @done="stageAdded"
        @close="closeAddStage()"
      >
      </stage-dialog> -->

    <!-- <stage-edit-dialog
        :dialog="dialogStage"
        :vacancyStages="vacancy.candidacies[getCandidacyIndex].stages"
        :vacancyId="vacancyId"
        @close="dialogStage = false"
        @done="stageUpdated"
      ></stage-edit-dialog> -->
  </v-expansion-panel>
</template>

<script>
import { API_URL } from "@/api";
import { mapGetters } from "vuex";
import {
  JOIN_OR_LEFT_INTERVIEWER_MUTATION,
  UPDATE_STAGE_RATING_MUTATION,
} from "../../../../../interview/graphql/Mutation.gql";
import { GET_VACANCY_BY_ID_QUERY } from "../../../../../interview/graphql/Query.gql";
import ExpansionPanelHeader from "./ExpansionPanelHeader.vue";
import Classification from "../../../../../interview/components/panel/finished/Classification.vue";
import Results from "../../../../../interview/components/panel/finished/Results.vue";
import RecruterList from "../../../../../interview/components/panel/RecruterList.vue";
import Comments from "../../../../../interview/components/panel/Comments.vue";
import Notes from "../../../../../interview/components/panel/Notes.vue";
//   import StageDialog from "../StageDialog.vue";
//   import StageEditDialog from "../StageEditDialog.vue";
import moment from "moment";
import AvatarGroup from "../../../../../interview/components/recruter/AvatarGroup.vue";
export default {
  name: "ExpansionPanel",

  components: {
    ExpansionPanelHeader,
    Classification,
    Results,
    RecruterList,
    Comments,
    Notes,
    AvatarGroup,
    //   StageDialog,
    //   StageEditDialog,
  },

  props: {
    interviewId: { type: String },
    vacancyId: { type: String },
    interviews: { type: Array },
    isCompleted: { type: Boolean },
  },

  data: () => ({
    apiUrl: API_URL,
    isStageChange: false,
    noteDialog: false,
    knowledge: 40,
    selectedCandidate: undefined,
    selectedRecruter: undefined,
    selectedStage: undefined,
    loggedRecruiter: null,
    joined: false,
    master: false,
    isLoading: false,
    isLoading2: false,
    vacancy: null,
    language: {},
    dialogStage: false,
    dialog: true,
  }),

  apollo: {
    vacancy: {
      query: GET_VACANCY_BY_ID_QUERY,
      variables() {
        return {
          id: this.vacancyId,
          fromProfile: true,
        };
      },
      fetchPolicy: "no-cache",
      result({ data, loading }) {
        if (!loading) {
          this.vacancy = data.vacancy;
        }
      },
    },
  },

  watch: {
    interviews(updatedInterview) {
      // const FIRST_ELEMENT = 0;
      this.getCurrentSelected(updatedInterview);
      this.setCurrentSelectedRecruter(updatedInterview);
      this.setLoggedRecruiter(updatedInterview);

      const CURRENT_STAGE = this.getCurrentStage(this.selectedCandidate);
      this.selectedStage = CURRENT_STAGE.name;

      if (CURRENT_STAGE.state === "running") {
        clearInterval(this.cron);
      }
    },

    selectedCandidate(val) {
      const CURRENT_STAGE = this.getCurrentStage(val);

      const currentSelectedRecruter = CURRENT_STAGE.recruters.find(
        (findRecruter) => findRecruter.user.id === this.selectedRecruter.user.id
      );

      if (currentSelectedRecruter) {
        this.selectedRecruter = currentSelectedRecruter;
        this.selectedRecruter.isObserver = false;
      } else {
        this.selectedRecruter = CURRENT_STAGE.observers.find(
          (findObserver) =>
            findObserver.user.id === this.selectedRecruter.user.id
        );
        this.selectedRecruter.isObserver = true;
      }
    },

    loggedRecruiter(val) {
      if (!val.joined) {
        // eslint-disable-next-line no-undef
        Fire.$emit("left");
      }
    },
  },

  created() {
    const FIRST_ELEMENT = 0;
    const CURRENT_STAGE = this.getCurrentStage(this.interviews[FIRST_ELEMENT]);

    this.selectedStage = CURRENT_STAGE.name;

    this.selectedCandidate = this.interviews[FIRST_ELEMENT];
    const logggedRecruter = CURRENT_STAGE.recruters.find(
      (findRecruter) => findRecruter.user.id === this.userId
    );

    if (logggedRecruter) {
      this.selectedRecruter = logggedRecruter;
      this.selectedRecruter.isObserver = false;
    } else if (CURRENT_STAGE.observers.length > 0) {
      this.selectedRecruter = CURRENT_STAGE.observers.find(
        (findRecruter) => findRecruter.user.id === this.userId
      );
      this.selectedRecruter.isObserver = true;
    } else {
      this.selectedRecruter = CURRENT_STAGE.recruters[FIRST_ELEMENT];
    }

    this.setLoggedRecruiter(this.interviews);
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getCurrentUser",
      getPublishingLang: "library/publishingLang",
    }),

    userId() {
      return this.$root.$data.userId;
    },
    isGroup() {
      return this.interviews.length > 1;
    },
    buttonActions() {
      const currentStage = this.selectedCandidate.stages.find(
        (findStage) => findStage.name === this.selectedCandidate.currentStage
      );
      if (currentStage.state === "running" && this.isMaster) {
        return { text: this.$t("pause"), icon: "mdi-pause", value: "pause" };
      } else if (
        currentStage.state === "running" &&
        !this.isMaster &&
        !this.loggedRecruiter.joined
      ) {
        return {
          text: this.$t("interviewParticipate"),
          icon: "mdi-play",
          value: "join",
        };
      } else if (
        currentStage.state === "running" &&
        !this.isMaster &&
        this.loggedRecruiter.joined
      ) {
        return {
          text: this.$t("Goout"),
          icon: "mdi-logout",
          value: "left",
        };
      } else if (
        this.isObserver &&
        currentStage.state !== "running" &&
        !this.loggedRecruiter.joined
      ) {
        return {
          text: this.$t("interviewParticipate"),
          icon: "mdi-play",
          value: "join",
        };
      }
      return { text: this.$t("start"), icon: "mdi-play", value: "running" };
    },

    isRunning() {
      const currentStage = this.selectedCandidate.stages.find(
        (findStage) => findStage.name === this.selectedCandidate.currentStage
      );

      return currentStage.state === "running" && this.loggedRecruiter.joined;
    },

    isStageRunning() {
      const currentStage = this.selectedCandidate.stages.find(
        (findStage) => findStage.name === this.selectedCandidate.currentStage
      );

      return currentStage.state === "running";
    },

    isRunningButNotJoined() {
      const currentStage = this.selectedCandidate.stages.find(
        (findStage) => findStage.name === this.selectedCandidate.currentStage
      );

      return currentStage.state === "running" && !this.loggedRecruiter.joined;
    },

    isInterviewer() {
      const FIRST_ELEMENT = 0;
      const currentStage = this.getCurrentStage(this.interviews[FIRST_ELEMENT]);

      const interviewer = currentStage.recruters.find(
        (findRecruter) => findRecruter.user.id === this.userId
      );

      return !!interviewer;
    },

    isObserver() {
      const currentStage = this.selectedCandidate.stages.find(
        (findStage) => findStage.name === this.selectedCandidate.currentStage
      );

      const interviewer = currentStage.observers.find(
        (findObserver) => findObserver.user.id === this.userId
      );

      return !!interviewer;
    },

    isMaster() {
      return this.loggedRecruiter.isMaster;
    },

    getCandidacyIndex() {
      return this.vacancy.candidacies.findIndex(
        (candidacy) =>
          candidacy.candidate.id === this.selectedCandidate.interviewee.id
      );
    },
  },

  beforeDestroy() {
    clearInterval(this.cron);
  },

  methods: {
    openAddStage() {
      this.dialogStage = true;
    },
    dateFormat(date) {
      if (date) {
        return moment(date.substring(0, 10))
          .lang(this.$i18n.locale)
          .format("LL");
      }
    },
    closeOpen() {
      this.dialog = true;
    },
    stageUpdated(stages) {
      this.vacancy.candidacies[this.getCandidacyIndex].stages === stages;
      this.dialogStage = false;
    },
    closeAddStage() {
      this.dialogStage = false;
    },
    stageAdded(newStage) {
      console.log({ newStage });
      this.vacancy.candidacies = this.vacancy.candidacies.map((candidacy) => {
        candidacy.stages.push(newStage);
        return candidacy;
      });
    },
    async changeStage(stageIndex, rating) {
      if (this.isStageChange) {
        try {
          await this.$apollo.mutate({
            mutation: UPDATE_STAGE_RATING_MUTATION,
            variables: {
              id: this.vacancyId,
              stageIndex,
              candidateIndex: this.getCandidacyIndex,
              rating,
            },
          });
        } catch (error) {
          // this.error = formatError(error.message);
          this.showError = true;
        } finally {
          this.isStageChange = false;
        }
      } else {
        this.isStageChange = true;
      }
    },

    editEmail(candidateEmail) {
      const params = {
        interviewId: this.interviewId,
        candidateEmail,
      };
      // eslint-disable-next-line no-undef
      Fire.$emit("EditEmailDialog", params);
    },

    getCurrentSelected(updatedInterview) {
      const FIRST_ELEMENT = 0;

      const selectedCandidateIndex = updatedInterview.findIndex(
        (findInterview) =>
          (findInterview.interviewee &&
            this.selectedCandidate.interviewee &&
            findInterview.interviewee.id ===
              this.selectedCandidate.interviewee.id) ||
          (!findInterview.interviewee &&
            !this.selectedCandidate.interviewee &&
            findInterview.email === this.selectedCandidate.email)
      );

      this.selectedCandidate =
        selectedCandidateIndex > -1
          ? updatedInterview[selectedCandidateIndex]
          : updatedInterview[FIRST_ELEMENT];
    },

    setCurrentSelectedRecruter(updatedInterview) {
      const FIRST_ELEMENT = 0;
      const CURRENT_STAGE = this.getCurrentStage(
        updatedInterview[FIRST_ELEMENT]
      );

      let oldSelectedRecruter = CURRENT_STAGE.recruters.find(
        (findRecruter) => findRecruter.user.id === this.selectedRecruter.user.id
      );

      if (oldSelectedRecruter) {
        this.selectedRecruter = oldSelectedRecruter;
        this.selectedRecruter.isObserver = false;
      } else {
        oldSelectedRecruter = CURRENT_STAGE.observers.find(
          (findObserver) =>
            findObserver.user.id === this.selectedRecruter.user.id
        );
        this.selectedRecruter = oldSelectedRecruter;
        this.selectedRecruter.isObserver = true;
      }
    },

    setLoggedRecruiter(interview) {
      const FIRST_ELEMENT = 0;
      const CURRENT_STAGE = this.getCurrentStage(interview[FIRST_ELEMENT]);

      const logggedRecruiter = CURRENT_STAGE.recruters.find(
        (findRecruter) => findRecruter.user.id === this.userId
      );

      if (logggedRecruiter) {
        const isMaster = CURRENT_STAGE.master === this.userId;
        this.loggedRecruiter = logggedRecruiter;
        this.loggedRecruiter.isMaster = isMaster;
      } else {
        this.loggedRecruiter = CURRENT_STAGE.observers.find(
          (findObserver) => findObserver.user.id === this.userId
        );
      }
    },

    chageStage(stage) {
      const FIRST_ELEMENT = 0;
      const logggedRecruter = stage.recruters.find(
        (findRecruter) => findRecruter.user.id === this.userId
      );

      this.selectedStage = stage.name;

      if (logggedRecruter) {
        this.selectedRecruter = logggedRecruter;
        this.selectedRecruter.isObserver = false;
      } else if (stage.observers.length > 0) {
        this.selectedRecruter = stage.observers.find(
          (findRecruter) => findRecruter.user.id === this.userId
        );
        this.selectedRecruter.isObserver = true;
      } else {
        this.selectedRecruter = stage.recruters[FIRST_ELEMENT];
      }
    },

    getCurrentStage(interview) {
      if (interview) {
        return interview.stages.find(
          (findStage) => findStage.name === interview.currentStage
        );
      }
    },

    selectRecruter(recruter) {
      this.selectedRecruter = recruter;
    },

    updateState(state) {
      console.log("state: ", state);
      if (state === "join") {
        this.joinOrLeft(true);
      } else if (state === "left") {
        this.joinOrLeft(false);
      } else {
        this.isLoading2 = true;
        if (state === "running") {
          // eslint-disable-next-line no-undef
          Fire.$emit("startOrPauseInterviewInResultComponents", state);
          // eslint-disable-next-line no-undef
          Fire.$emit("joined");
        }

        if (state === "pause") {
          // eslint-disable-next-line no-undef
          Fire.$emit("startOrPauseInterviewInResultComponents", state);
          // eslint-disable-next-line no-undef
          Fire.$emit("left");
        }
      }
    },

    openOptionsReSchedule() {
      const params = {
        selectedCandidate: this.selectedCandidate,
        interviews: this.interviews,
        interviewId: this.interviewId,
      };
      // eslint-disable-next-line no-undef
      Fire.$emit("OptionsReSchedule", params);
    },

    openNotes() {
      this.noteDialog = true;
    },

    openFinishDialog() {
      const params = {
        interviewId: this.interviewId,
        interviews: this.interviews,
      };
      // eslint-disable-next-line no-undef
      Fire.$emit("FinishInterview", params);
    },

    openCancelDialog() {
      const params = {
        interviewId: this.interviewId,
        interviews: this.interviews,
      };
      // eslint-disable-next-line no-undef
      Fire.$emit("CancelInterview", params);
    },

    splitName(name) {
      return name.split(" ")[0];
    },

    async joinOrLeft(isJoin) {
      const FIRST_ELEMENT = 0;
      this.isLoading2 = true;
      const candidates = this.getCandidateIdsFromInterviews();
      const stage = this.interviews[FIRST_ELEMENT].currentStage;
      try {
        await this.$apollo.mutate({
          mutation: JOIN_OR_LEFT_INTERVIEWER_MUTATION,
          variables: {
            interviewUpdateStateInput: {
              interviewId: this.interviewId,
              candidates,
              state: "running",
              stage,
              isJoin,
            },
          },
        });
        if (isJoin) {
          // eslint-disable-next-line no-undef
          Fire.$emit("joined");
        } else {
          // eslint-disable-next-line no-undef
          Fire.$emit("left");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading2 = false;
      }
    },

    getCandidateIdsFromInterviews() {
      const candidates = this.interviews.map((mapInterview) => {
        return mapInterview.interviewee
          ? mapInterview.interviewee.id
          : mapInterview.email;
      });

      return candidates;
    },
  },
};
</script>

<style scoped>
.results {
  background-color: rgba(253, 240, 215, 0.7);
}

.whirelab-results {
  background-color: rgba(253, 240, 215, 0.7);
  padding: 20px;
  border-radius: 10px;
}
</style>
